import Box from '@mui/material/Box';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../../../shared/source/context/context';
import { Headline } from '../../../../../design/components/Typography';

import type { FunctionComponent } from 'react';

export const UserBackgroundHistoriesTitle: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Box pt={4}>
            <Headline variant="h4">{translate('pages.recruiter-profile.background.title')}</Headline>
        </Box>
    );
};
